import { createAnalyticEvent } from '../../shared/analytics/services';
import {
  NavigationMapEntry,
  TrackingAction,
  TrackingProperty,
  WEB_NAVIGATION_MAP,
} from '@rapid-recovery-agency-inc/insightt-shared';

export const ACTIVE_MODAL = 'ACTIVE_MODAL';
export const SELECTED_CASE = 'SELECTED_CASE';
export const RDN_CASES = 'RDN_CASES';
export const VIN = 'VIN';
export const LOADING_SEARCH_CASES = 'LOADING_SEARCH_CASES';
export const LOADING_VEHICLE_SPOTTED_FORM = 'LOADING_VEHICLE_SPOTTED_FORM';

export const trackOpenModalSpottedVehicleShiftDashboard = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_SPOT,
  (role: string) => ({ $role: role }),
);

export const trackOpenModalSpottedVehicleAlertShiftDashboard = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED_ALERT.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_ALERT,
  (role: string) => ({ $role: role }),
);

export const trackOpenModalSpottedVehicleTopBar = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_SPOT,
  (role: string) => ({ $role: role }),
);

export const trackOpenModalSpottedVehicleAlertTopBar = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED_ALERT.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_ALERT,
  (role: string) => ({ $role: role }),
);

export const trackSelectCaseModalMatchDashboard = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_SPOT.subViews.SELECT_CASE_MODAL_MATCH,
  (role: string) => ({ $role: role }),
);

export const trackSelectCaseModalMatchTopBar = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_SPOT.subViews.SELECT_CASE_MODAL_MATCH,
  (role: string) => ({ $role: role }),
);
export const trackSelectCaseModalFormDashboard = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_SPOT.subViews.VEHICLE_SPOTTED_FORM,
  (role: string) => ({ $role: role }),
);

export const trackSelectCaseModalFormTopBar = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_SPOT.subViews.VEHICLE_SPOTTED_FORM,
  (role: string) => ({ $role: role }),
);

export const trackNoCaseModalMatchDashboard = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_SPOT.subViews.NO_OPEN_CASE_MODAL_NO_MATCH,
  (role: string) => ({ $role: role }),
);

export const trackNoCaseModalMatchTopBar = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_SPOT.subViews.NO_OPEN_CASE_MODAL_NO_MATCH,
  (role: string) => ({ $role: role }),
);

export const trackNoCaseModalMatchAlertDashboard = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED_ALERT.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_ALERT.subViews.VEHICLE_SPOTTED_ALERT_FORM,
  (role: string) => ({ $role: role }),
);

export const trackNoCaseModalMatchAlertTopBar = createAnalyticEvent(
  TrackingAction.OPEN_MODAL,
  WEB_NAVIGATION_MAP.ON_SHIFT_DASHBOARD.features.VEHICLE_SPOTTED_ALERT.views.ON_SHIFT_DASHBOARD.subViews
    .VIN_INPUT_MODAL_ALERT.subViews.VEHICLE_SPOTTED_ALERT_FORM,
  (role: string) => ({ $role: role }),
);

export const trackSpottedVehicle = (action: TrackingAction, entry: NavigationMapEntry, data: TrackingProperty) => {
  createAnalyticEvent(action, entry)(data);
};

export const trackShowExpiredToggleClicked = createAnalyticEvent(
  TrackingAction.CLICK,
  WEB_NAVIGATION_MAP.SPOTTED_VEHICLES.features.FILTER.views.SPOTTED_VEHICLES.subViews.FILTER_MODAL,
  (showExpired: boolean) => ({
    showExpired,
  }),
);
